import { Component, OnInit, Inject } from '@angular/core';
import { BaseDialogFormViewDirective } from '@app/shared/base-views/base-dialog-form-view.directive';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from '@app/core/services/toast/toast.service';
import { LotBuildPermissions } from '@app/core/permissions';
import { IProductDto, IProductBundleProductDto } from '@app/logic/products/interfaces/i.product.dto';
import { IProductMappedItem, ProductLogicService, ProductMappedItem } from '@app/logic/products';
import { IProductLogicService } from '@app/logic/products/interfaces/i.product.logic.service';
import { LookupService } from '@app/core/services/lookup/lookup.service';
import { BundleTemplatesLogicService } from '@app/logic/bundle-templates';
import { TradeTypesLogicService } from '@app/logic/trade-types/trade-types.logic.service';
import { CategoryLogicService } from '@app/logic/product-categories';
import { IBundleTemplateItemDto, IUpdateBundleProductDto, PRODUCT_SEARCH_TYPE_ENUM } from '@classictechsolutions/hubapi-transpiled-enums';
import { take } from 'rxjs';

interface IData {
    bundleProductItem: any;
    bundleTemplateItem: any;
    mappedItem: ProductMappedItem;
}

@Component({
    templateUrl: './add-product-to-templated-bundle-dialog.component.html',
    styleUrls: ['./add-product-to-templated-bundle-dialog.component.scss'],
    providers: [
        LookupService,
        BundleTemplatesLogicService,
        ProductLogicService,
        TradeTypesLogicService,
        CategoryLogicService
    ],
    standalone: false
})
export class AddProductToTemplatedBundleDialogComponent
    extends BaseDialogFormViewDirective<IProductDto, IProductMappedItem, IProductLogicService> implements OnInit {
    public static readonly MIN_WIDTH = '600px';

    public bundleProductItem: any;
    public bundleTemplateItem: IBundleTemplateItemDto;
    public selectedProduct: IProductDto;
    public productSearchText: string;
    public readonly PRODUCT_SEARCH_TYPE_ENUM = PRODUCT_SEARCH_TYPE_ENUM;

    constructor(
        public readonly dialogRef: MatDialogRef<AddProductToTemplatedBundleDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public readonly data: IData,
        @Inject(ToastService) public readonly toastService: ToastService,
        @Inject(LookupService) public readonly lookupService: LookupService,
        @Inject(LotBuildPermissions) public readonly lotBuildPermissions: LotBuildPermissions,
        protected readonly bundleTemplatesLogicService: BundleTemplatesLogicService,
        protected readonly productLogicService: ProductLogicService
    ) {
        super(dialogRef, toastService);
        this.bundleProductItem = data.bundleProductItem;
        this.bundleTemplateItem = data.bundleTemplateItem;
        this.mappedItem = data.mappedItem;
    }

    public ngOnInit(): void {
        super.ngOnInit();
        if (this.bundleProductItem) {
            this.selectedProduct = this.bundleProductItem;
        } else {
            this.bundleProductItem = {};
        }
    }

    public getTitle(): string {
        return 'Add Item to Bundle';
    }

    public productSelected(value: IProductBundleProductDto | any): void {
        if (value) {
            this.selectedProduct = value;
        }
    }

    public saveBundleProduct(): void {
        this.bundleProductItem.isChangeable = !this.bundleTemplateItem.isLocked;
        const bundleProduct: IUpdateBundleProductDto = {
            bundleTemplateItemId: this.bundleTemplateItem.id,
            id: this.bundleProductItem ? this.bundleProductItem.id as number : undefined,
            isChangeable: !this.bundleTemplateItem.isLocked,
            isRequired: this.bundleTemplateItem.isRequired,
            productId: this.selectedProduct.id,
            quantity: this.bundleProductItem.quantity
        };
        this.mappedItem.saveBundleProduct(bundleProduct).pipe(take(1)).subscribe((item) => {
            if (item) {
                this.mappedItem.products.forEach((sr: any) => {
                    item.products.forEach((ir: any) => {
                        if (sr.id === ir.id) {
                            Object.assign(sr, ir);
                        }
                    });
                });
                this.handleNext(item);
            } else {
                this.handleError(item);
            }
        });
    }
}
